module.exports = __webpack_public_path__ + "static/img/produto_g.b390337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/uva/produto_g.png
// module id = fhLZ
// module chunks = 0